import axios from 'axios'
import { BASE_URL, API_VERSION, EVENTS } from '../endpoints'

export const GET_ALL_EVENTS = 'GET_ALL_EVENTS'
export const SELECT_EVENT = 'SELECT_EVENT'
export const EDIT_EVENT = 'EDIT_EVENT'

export const getAllEvents = (query) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    const queryString = new URLSearchParams(query).toString();

    return axios.get(`${BASE_URL}${EVENTS}/organizer?${queryString}`, options)
        .then((response) => {
            dispatch({
                type: GET_ALL_EVENTS,
                payload: {
                    events: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const updateEvent = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.patch(`${BASE_URL}${EVENTS}/${id}`, payload, apiHeader)
        .then((response) => {
            console.log(response.data)
            dispatch({
                type: EDIT_EVENT,
                payload: {
                    events: response.data.data,
                    eventId: id
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            console.log(error)
            return Promise.reject(error.response?.data?.error);
        });
};

export const selectEvent = (id) => (dispatch) => {
    dispatch({
        type: SELECT_EVENT,
        payload: {
            eventId: id,
        }
    });
}